// extracted by mini-css-extract-plugin
module.exports = {"container":"UserReminder_container__2nTwh","weekday":"UserReminder_weekday__-uaWE","alarm":"UserReminder_alarm__k5HtV"};